module.exports = __webpack_public_path__ + "de87c5ef66ae4f5d0172cf7bc7723cfc.mtl";